import React, { useMemo } from 'react';
import { Campaign, SortField, SortOrder } from '../../types/Campaign';
import { CampaignCard } from '../molecules/CampaignCard';
import { CampaignCardMobile } from '../molecules/CampaignCardMobile';
import { sortCampaigns } from '../../utils/campaignUtils';

interface CampaignListProps {
  campaigns: Campaign[];
  sortField: SortField;
  sortOrder: SortOrder;
}

export const CampaignList: React.FC<CampaignListProps> = ({
  campaigns,
  sortField,
  sortOrder,
}) => {
  const sortedCampaigns = useMemo(() => {
    return sortCampaigns(campaigns, sortField, sortOrder);
  }, [campaigns, sortField, sortOrder]);

  if (sortedCampaigns.length === 0) {
    return (
      <div className="text-center py-20 bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700">
        <p className="text-gray-600 dark:text-gray-400 text-lg font-medium">Nenhuma campanha encontrada</p>
        <p className="text-gray-400 dark:text-gray-500 text-sm mt-2">Tente ajustar os filtros de busca</p>
      </div>
    );
  }

  return (
    <>
      {/* Desktop List View */}
      <div className="hidden lg:flex flex-col gap-3">
        {sortedCampaigns.map((campaign) => (
          <CampaignCard key={campaign.campaignId} campaign={campaign} />
        ))}
      </div>

      {/* Mobile/Tablet Grid View */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:hidden">
        {sortedCampaigns.map((campaign) => (
          <CampaignCardMobile key={campaign.campaignId} campaign={campaign} />
        ))}
      </div>
    </>
  );
};
